import ClientAdd from './ClientAdd';

export default ClientAdd;
